import GpsIcon from 'components/elements/icons/GpsIcon'
import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

/**
 * 場所選択マップ、はじめの場所ボタン
 */
const StartLocation: React.FC<StartLocationProps> = (props) => {
  return (
    <StyledStartLocation onClick={props.onClickStartLocation}>
      <Text color="var(--color-main)" fontSize="11px">
        {props.text}
      </Text>
      <GpsIcon />
    </StyledStartLocation>
  )
}

export type StartLocationProps = {
  onClickStartLocation: (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void
  text: string
}

const StyledStartLocation = styled.div`
  position: absolute;
  top: 24px;
  left: 16px;
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  padding: 8px;
  background: var(--color-text-for-main-background);
  border-radius: 80px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.16);

  > * {
    margin: 0 4px;
  }
`

export default React.memo(StartLocation)
